import { Command } from '../../../../../../core/command/Command.js';
export class addFractionalFeesCommandResponse {
    constructor(payload) {
        this.payload = payload;
    }
}
export class addFractionalFeesCommand extends Command {
    constructor(tokenId, collectorId, amountNumerator, amountDenominator, min, max, net, collectorsExempt) {
        super();
        this.tokenId = tokenId;
        this.collectorId = collectorId;
        this.amountNumerator = amountNumerator;
        this.amountDenominator = amountDenominator;
        this.min = min;
        this.max = max;
        this.net = net;
        this.collectorsExempt = collectorsExempt;
    }
}
